import React from "react";
import PrivacyPolicy from "../Components/Other/PrivacyPolicy";

const Privacy = () => {
  return <PrivacyPolicy />;
};

export default Privacy;
